// src/components/store/sections/testimonials/TestimonialV22ClayreviewsCoralFlame.tsx
"use client";

import React from "react";
import DynamicTestimonialVariant from "./DynamicTestimonialVariant";

export default function TestimonialV22ClayreviewsCoralFlame(props: any) {
  return (
    <DynamicTestimonialVariant
      variantNumber={22}
      archKey="clay_reviews"
      archLabel="3D Clay Review Deck"
      palName="CoralFlame"
      grad="from-orange-500 via-rose-500 to-pink-700"
      lightBg="bg-orange-50"
      textCol="text-orange-700"
      borderCol="border-orange-200"
      btnCls="bg-rose-600 hover:bg-rose-700"
      hexCol="#f97316"
      {...props}
    />
  );
}
